import React, { useEffect, useState } from "react";
import { getWindowForms } from "../../Forms/api";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Mirrors the Window Quote Manager's KPIs: the incoming queue is any active
// form with no quoter assigned.
const ACTIVE_STATUSES = [
  "Submitted",
  "Under Review",
  "Awaiting Sales Approval",
  "Needs Revision",
  "Reviewing Revisions",
];

const assigneeIdOf = (entry) => Number(entry?.assigned_to?.userID) || null;

const WindowQuoteManagerWidget = () => {
  const [forms, setForms] = useState(null);

  useEffect(() => {
    getWindowForms((data) => setForms(Array.isArray(data) ? data : []));
  }, []);

  if (!forms) {
    return (
      <WidgetFrame title="Window Quote Manager" to="/windowdoor/quote-manager">
        <WidgetEmpty>Loading the queue…</WidgetEmpty>
      </WidgetFrame>
    );
  }

  const active = forms.filter((form) => ACTIVE_STATUSES.includes(form.status));
  const unassigned = active.filter((form) => !assigneeIdOf(form));
  const awaitingSales = active.filter(
    (form) => form.status === "Awaiting Sales Approval"
  );

  return (
    <WidgetFrame title="Window Quote Manager" to="/windowdoor/quote-manager">
      <div className="grid grid-cols-3 gap-2">
        <WidgetStat value={unassigned.length} label="Unassigned" />
        <WidgetStat value={active.length} label="Active" />
        <WidgetStat value={awaitingSales.length} label="With sales" />
      </div>
    </WidgetFrame>
  );
};

export default WindowQuoteManagerWidget;
